import {NgModule} from '@angular/core';
import {BarcodeScannerComponent} from './barcode-scanner.component';
import {PagesSharedModule} from '../../../pages/pages-shared.module';
import {ZXingScannerModule} from '@zxing/ngx-scanner';

@NgModule({
    imports: [
        PagesSharedModule,
        ZXingScannerModule
    ],
    declarations: [
        BarcodeScannerComponent
    ],
    entryComponents: [],
    exports: [
        BarcodeScannerComponent
    ]
})
export class BarcodeScannerModule {
}
